import FillBlanks from "../../components/ClassOne/EnvironmentScience/Plants/FillBlanks";
import MultipleChoice from "../../components/ClassOne/EnvironmentScience/Plants/MultipleChoice";
import OddOneOut from "../../components/ClassOne/EnvironmentScience/Plants/OddOneOut";
import TrueFalse from "../../components/ClassOne/EnvironmentScience/Plants/TrueFalse";

// Define the type for menu items
interface MenuItem {
    url: string;
    title: string;
    component?: React.FC; // Optional React functional component
    subMenu?: MenuItem[]; // Allow subMenu to be an array of MenuItem
}


const topics: MenuItem[] = [
    { url: "/class-one/environmental-science/plants/fill-blanks", title: "Fill in the Blanks", component: FillBlanks },
    { url: "/class-one/environmental-science/plants/odd-out", title: "Odd One Out", component: OddOneOut },
    { url: "/class-one/environmental-science/plants/true-false", title: "True or False", component: TrueFalse },
    { url: "/class-one/environmental-science/plants/multiple-choice-question", title: "Multiple Choice Questions", component: MultipleChoice },
];

export default topics;